var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProsessImg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 31H145V125H38V31Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 30.5H145.5V125.5H37.5V30.5ZM38.5 31.5V124.5H144.5V31.5H38.5Z",
    fill: "#555555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 36H55V124.333L45 142V36Z",
    fill: "#A8B1CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 36C44.5 35.7239 44.7239 35.5 45 35.5H55C55.2761 35.5 55.5 35.7239 55.5 36V124.333C55.5 124.42 55.4777 124.505 55.4351 124.58L45.4351 142.246C45.3233 142.444 45.0923 142.541 44.8727 142.484C44.653 142.426 44.5 142.227 44.5 142V36ZM45.5 36.5V140.102L54.5 124.202V36.5H45.5Z",
    fill: "#555555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128 36H138V142L128 124.333V36Z",
    fill: "#A8B1CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.5 36C127.5 35.7239 127.724 35.5 128 35.5H138C138.276 35.5 138.5 35.7239 138.5 36V142C138.5 142.227 138.347 142.426 138.127 142.484C137.908 142.541 137.677 142.444 137.565 142.246L127.565 124.58C127.522 124.505 127.5 124.42 127.5 124.333V36ZM128.5 36.5V124.202L137.5 140.102V36.5H128.5Z",
    fill: "#555555"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33H45V139H38V33Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 32.5H45.5V139.5H37.5V32.5ZM38.5 33.5V138.5H44.5V33.5H38.5Z",
    fill: "#555555"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138 36H145V142H138V36Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.5 35.5H145.5V142.5H137.5V35.5ZM138.5 36.5V141.5H144.5V36.5H138.5Z",
    fill: "#555555"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31H145V38H38V31Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 30.5H145.5V38.5H37.5V30.5ZM38.5 31.5V37.5H144.5V31.5H38.5Z",
    fill: "#555555"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.468 87.2924L114.358 97.7622L104.676 101.844L98.8622 95.123C97.5508 101.833 100.456 108.943 106.648 112.684C112.893 116.458 120.618 115.677 125.954 111.295L152.589 127.389C155.23 128.985 158.664 128.137 160.26 125.497C161.855 122.856 161.008 119.422 158.367 117.826L131.732 101.733C133.129 94.9714 130.227 87.7694 123.982 83.9957C117.79 80.2546 110.144 80.9901 104.814 85.272L113.468 87.2924ZM157.034 123.547C157.42 122.907 157.215 122.075 156.575 121.688C155.935 121.301 155.103 121.507 154.716 122.147C154.329 122.787 154.535 123.619 155.175 124.006C155.815 124.392 156.647 124.187 157.034 123.547Z",
    fill: "#4267EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21 112L56 123V161L21 148V112Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56 123L84 107L51 98L21 112L56 123Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84 107L56 123V161L84 143V107Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1367 115.5L42.0004 118.6V135L40.7674 132.542L39.5344 134.084L38.3015 131.626L37.0685 133.168L35.8356 130.71L34.6026 132.252L33.3697 129.794L32.1367 131.336V115.5Z",
    fill: "#4267EB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 115.5L42.0002 118.5L71.0002 103.5L61.5002 101L32.5002 115.5Z",
    fill: "#4267EB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7042 111.597C20.8325 111.503 20.998 111.475 21.1499 111.523L56.1499 122.523C56.3583 122.588 56.5 122.782 56.5 123V161C56.5 161.164 56.4199 161.317 56.2854 161.411C56.151 161.504 55.9794 161.526 55.8259 161.469L20.8259 148.469C20.63 148.396 20.5 148.209 20.5 148V112C20.5 111.841 20.5758 111.691 20.7042 111.597ZM21.5 112.681V147.652L55.5 160.281V123.367L21.5 112.681Z",
    fill: "#555555"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7886 97.5469C50.8958 97.4969 51.0174 97.4865 51.1316 97.5176L84.1316 106.518C84.3267 106.571 84.4705 106.736 84.496 106.937C84.5215 107.138 84.4237 107.334 84.2481 107.434L56.2481 123.434C56.1272 123.503 55.9829 123.519 55.8501 123.477L20.8501 112.477C20.6533 112.415 20.5147 112.239 20.5011 112.033C20.4875 111.827 20.6016 111.634 20.7886 111.547L50.7886 97.5469ZM51.0453 98.5306L22.3777 111.909L55.9416 122.458L82.7039 107.165L51.0453 98.5306Z",
    fill: "#555555"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.251 106.568C84.0968 106.478 83.9067 106.477 83.7519 106.566L55.7519 122.566C55.5962 122.655 55.5 122.821 55.5 123V161C55.5 161.183 55.5999 161.351 55.7604 161.439C55.921 161.527 56.1165 161.52 56.2704 161.421L84.2704 143.421C84.4135 143.329 84.5 143.17 84.5 143V107C84.5 106.822 84.4051 106.657 84.251 106.568ZM83.5 107.862V142.727L56.5 160.084V123.29L83.5 107.862Z",
    fill: "#555555"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProsessImg5);
export default __webpack_public_path__ + "static/media/prosess-img5.dea37ab2ddbbf03f89d715041a67137a.svg";
export { ForwardRef as ReactComponent };